var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchData } from './base';
export function fetchAdminDatePosts(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: '/api/date_posts',
            params: params
        });
    });
}
export function fetchAdminDatePost(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/date_posts/${id}`
        });
    });
}
export function pauseAdminDatePost(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/date_posts/${id}/pause`,
            options: {
                method: 'POST'
            }
        });
    });
}
export function resumeAdminDatePost(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/date_posts/${id}/resume`,
            options: {
                method: 'POST'
            }
        });
    });
}
export function deleteAdminDatePost(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchData({
            endpoint: `/api/date_posts/${id}`,
            options: {
                method: 'DELETE'
            }
        });
    });
}
